import { withTrackEvent } from "@newsela/snitch";
import Link from "@/components/Link/";
import { SidebarItem } from "../SidebarNavigationList";
import { listNavigationItemCss } from "../SidebarNavigationList.style";
import { LinkTrackingProps } from "../SidebarNavigationItem/SidebarNavigationItem";

const LinkWithTrackEvent = withTrackEvent(Link);

interface SidebarSubmenuListProps {
  items: SidebarItem[];
  activeItemId: SidebarItem["id"] | undefined;
  anchorBaseUrl: string;
  queryString: string;
  linkTrackingProps: LinkTrackingProps;
  qaSelector: string;
}

const SidebarSubmenuList = (props: SidebarSubmenuListProps) => {
  const {
    activeItemId,
    anchorBaseUrl,
    items,
    queryString,
    linkTrackingProps,
    qaSelector,
  } = props;

  return (
    <>
      {items.map((item) => (
        <li
          key={item.name}
          css={listNavigationItemCss({
            isActive: item.id === activeItemId,
            isSubmenuLink: true,
          })}
        >
          <LinkWithTrackEvent
            href={`${anchorBaseUrl}${item?.id}${queryString}`}
            dataProps={{
              "data-qa-selector": qaSelector,
            }}
            isInline
            {...linkTrackingProps}
          >
            {item.name}
          </LinkWithTrackEvent>
        </li>
      ))}
    </>
  );
};

export default SidebarSubmenuList;
